import FinanceSerializer from './base';

export default class Ledger extends FinanceSerializer {
  normalize(modelClass, payload) {
    let defaults = {
      isHidden: false,
    };
    Object.assign(defaults, payload);
    Object.assign(payload, defaults);
    return super.normalize(...arguments);
  }
}
